/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { all, takeLatest } from 'redux-saga/effects';
import { fetchWrapperFunc } from '../../../utils';
import { getPlaylistAdminApi } from '../../System/systemConfig';
import { PLAYLIST_STAT_LOAD, setPlaylistStatistics } from './actions';

const playlistApi = getPlaylistAdminApi();

function* loadPlaylistStatisticsGenerator() {
    yield* fetchWrapperFunc(() => playlistApi.getStatistics(), [r => setPlaylistStatistics(r)]);
}

function* watchPlaylistStatistics() {
    yield takeLatest(PLAYLIST_STAT_LOAD, loadPlaylistStatisticsGenerator);
}

export function* playlistStatisticsSaga() {
    yield all([watchPlaylistStatistics()]);
}
